export default __webpack_public_path__ + "static/media/ser6.a862a88e.jpg";